/**
 * Osmosis brand tokens — derived from "Osmosis 2026 Brand Identity Guidelines"
 * (Patch 26.1). Single source of truth for colors and typography so components
 * stop hardcoding hex values. Import these or consume them via the MUI theme.
 */

// ── Core palette ─────────────────────────────────────────────────────────────
export const OSMO = {
    /** OSMO Green — primary brand color. HEX 8BC441 */
    green: '#8BC441',
    /** Darker green for hover/pressed states. HEX 5C8529 */
    greenDark: '#5C8529',
    /** Soft green tint for subtle fills. */
    greenSoft: 'rgba(139, 196, 65, 0.12)',
    /** OSMO Black — primary background. HEX 221F1F */
    black: '#221F1F',
    /** Slightly lifted surface for cards/paper above the black background. */
    surface: '#2B2828',
    /** Hairline borders / dividers on dark surfaces. */
    border: 'rgba(255, 255, 255, 0.12)',
    /** OSMO White. HEX FFFFFF */
    white: '#FFFFFF',
    /** OSMO Teal — accent ONLY (per guidelines). HEX 508991 */
    teal: '#508991',
    tealDark: '#417279',
} as const

// ── Infographic palette (charts) ─────────────────────────────────────────────
// From the guidelines' "Infographic Color Palette". Ordered for categorical use.
export const INFOGRAPHIC_PALETTE = [
    '#8BC441', // green
    '#508991', // teal
    '#FFBF00', // amber
    '#AA3E98', // magenta
    '#E00000', // red
    '#5C8529', // green dark
    '#417279', // teal dark
    '#FFD455', // amber light
    '#8C337E', // magenta dark
    '#BB0000', // red dark
] as const

export const INFOGRAPHIC_LIGHT = {
    blue: '#D9EBFF',
    teal: '#C3DADD',
    red: '#FF9FA0',
    magenta: '#E6BADF',
    amber: '#FFEAAA',
} as const

// ── Typography ───────────────────────────────────────────────────────────────
// Inter (primary) + Oxygen Mono (secondary) per guidelines, with graceful
// system fallbacks so nothing breaks before the webfonts are installed.
export const FONT_FAMILY_PRIMARY =
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
export const FONT_FAMILY_MONO =
    "'Oxygen Mono', 'Roboto Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace"

// ── Shared shadows / radii ───────────────────────────────────────────────────
export const RADIUS = 10
export const SHADOW_SOFT = '0 8px 24px rgba(0, 0, 0, 0.45)'
